export default {
  // Configure the action form
  createActionUrl: null,
  fields: [],
  extraParams: {},

  action: {},

  showingActionFormModal: false,

  windowWidth: window.innerWidth,

  actionTakerName: null,

  submittingCreateAction: false,
  retryingSubmit: false,
  retryCount: 0,

  disclaimerContent: {
    beforeSubmit: '',
    afterSubmit: ''
  },

  notMeLink: {
    url: null,
    method: null
  },

  oneClickFromContext: false,

  tryOneClickFromCrm: false,
  oneClickFromCrm: false,
  crmOneClickUrl: null,
  oneClickFromCrmStatus: null,

  oneClickFieldMappings: null,
  fieldsSetFromCrm: [],
  oneClickDataFromCrm: null,

  // Prefill forms consent
  askForPrefillFormsConsentIfNeeded: false,
  prefillFormsConsent: {
    updatePrefillFormsPath: null,
    campaignSlug: null,
    utmParams: {}
  },
  requestingPrefillFormsConsent: false,

  globalSubscriptionCheck: {
    enabled: false,
    url: null,
    email: null,
    isSubscribed: false,
    suppressEmailOptInFieldIfCrmLookupFails: false,
    crmLookupFailed: false
  },

  // Handle submission: Needs email confirmation
  awaitingEmailConfirmation: false,

  // Handle submission: Error display
  toastErrorMessage: null,
  nonRecoverableError: null,
  validationErrors: {},

  // Post-submission: Show daisy chain
  showDaisyChain: false,
  completingAction: false,
  baseDaisyChainsPath: null,
  daisyChainRepeatedAction: false,

  // Post-submission: Sharing
  sharing: null
}
